import Vue from 'vue'
import * as types from '@/constants/store-mutation-types'

import { set as setData } from '@/lib/local-storage'

const getParams = (state, courierId) => {
  return {
    typeId: state.orderObject.typeId,
    rangeId: state.orderObject.rangeId,
    courierId
  }
}

const validateCache = (cache, params) => {
  return (
    cache &&
    cache.params.typeId === params.typeId &&
    cache.params.rangeId === params.rangeId &&
    cache.params.courierId === params.courierId &&
    cache.data &&
    cache.data.length
  )
}

export default {
  [types.LOGIN]({ commit, getters }, account) {
    // ! TODO: use coockie instead local-storage
    setData(types.ACCOUNT_COOKIE, account)
    commit(types.SET_ACCOUNT, account)
    if (getters.webView) {
      // eslint-disable-next-line no-undef
      app.login(
        account.accessToken,
        getters.clientType,
        String(getters.fingerprint),
        getters.appVersion
      )
    }
  },
  [types.SET_PERMISSION]({ commit }, permissions) {
    setData(types.PERMISSION, permissions)
    commit(types.SET_PERMISSION, permissions)
  },
  // ! register-order
  [types.ACTION_FETCH_CAR_LIST]({ state, commit }, api, courierId) {
    const cache = state.orderDataCache.car
    const params = getParams(state, courierId)

    if (validateCache(cache, params)) {
      return Promise.resolve(cache.data)
    }

    return api.orderSupported
      .carTypeList(params, true)
      .then((response) => {
        const data = response.filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )

        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'car',
          value: {
            data,
            params
          }
        })
        return data
      })
      .catch((error) => {
        // Vue.prototype.$showError(error.toString())
        return []
      })
  },
  [types.ACTION_FETCH_EMPLOYEE_LIST]({ state, commit }, api, courierId) {
    const cache = state.orderDataCache.employee
    const params = getParams(state, courierId)

    if (validateCache(cache, params)) {
      return Promise.resolve(cache.data)
    }

    return api.orderSupported
      .employeeList(params, true)
      .then((response) => {
        const data = response.filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )

        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'employee',
          value: {
            data,
            params
          }
        })
        return data
      })
      .catch((error) => {
        // Vue.prototype.$showError(error.toString())
        return []
      })
  },
  [types.ACTION_FETCH_ITEM_LIST]({ state, commit }, api, courierId) {
    const cache = state.orderDataCache.item
    const params = getParams(state, courierId)

    if (validateCache(cache, params)) {
      return Promise.resolve(cache.data)
    }

    const apiCalls = [
      api.orderSupported.itemGroupList(params, true),
      api.orderSupported.itemTypeList(params, true)
    ]

    return Promise.all(apiCalls)
      .then((response) => {
        const itemGroups = response[0].filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )
        const itemTypes = response[1].filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )

        const data = itemGroups.reduce((itemGroups, itemGroup) => {
          const items = itemTypes.filter(
            (item) => item.group.id === itemGroup.id
          )

          if (items && items.length)
            itemGroups.push({
              id: itemGroup.id,
              title: itemGroup.title,
              items,
              description: itemGroup.description
            })

          return itemGroups
        }, [])

        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'item',
          value: {
            data,
            params
          }
        })
        return data
      })
      .catch((error) => {
        // Vue.prototype.$showError(error.toString())
        return []
      })
  },
  [types.ACTION_FETCH_CITY_LIST]({ state, commit }, api) {
    const cache = state.orderDataCache.city

    if (cache && cache.data && cache.data.length) {
      return Promise.resolve(cache.data)
    }

    return api.geo
      .cityList({}, true)
      .then((data) => {
        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'city',
          value: {
            data
          }
        })

        return data
      })
      .catch((error) => {
        // Vue.prototype.$showError(error.toString())
        return []
      })
  },
  [types.ACTION_FETCH_LOAD_LIST]({ state, commit }, api, courierId) {
    const cache = state.orderDataCache.load
    const params = getParams(state, courierId)

    if (validateCache(cache, params)) {
      return Promise.resolve(cache.data)
    }

    return api.orderSupported
      .loadList(params, false)
      .then((response) => {
        const data = response.filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )

        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'load',
          value: {
            data,
            params
          }
        })
        return data
      })
      .catch((error) => {
        // Vue.prototype.$showError(error.toString())
        return []
      })
  },
  [types.ACTION_FETCH_PACKAGE_TYPE_LIST]({ state, commit }, api, courierId) {
    const cache = state.orderDataCache.packageType
    const params = getParams(state, courierId)

    if (validateCache(cache, params)) {
      return Promise.resolve(cache.data)
    }

    return api.orderSupported
      .packageList(params, false)
      .then((response) => {
        const data = response.filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )

        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'packageType',
          value: {
            data,
            params
          }
        })
        return data
      })
      .catch((error) => {
        // Vue.prototype.$showError(error.toString())
        return []
      })
  },
  [types.ACTION_SET_ORDER_ACCEPTED_OFFERS]({ commit }, offers) {
    const uniqueId = Math.random().toString(16).slice(2)
    commit(types.SET_ORDER_ACCEPTED_OFFERS, { offers, uniqueId })
    return Promise.resolve(uniqueId)
  },
  [types.ACTION_FETCH_CAR_CATEGORY_LIST]({ state, commit }, api, courierId) {
    const cache = state.orderDataCache.carCategory
    const params = getParams(state, courierId)

    if (validateCache(cache, params)) {
      return Promise.resolve(cache.data)
    }

    return api.orderSupported
      .carCategoryList(params, true)
      .then((response) => {
        const data = response.filter(
          (item) =>
            item.courierSupported && item.rangeTypeSupported && item.enabled
        )

        commit(types.SET_ORDER_CACHE_DATA_BY_KEY, {
          key: 'carCategory',
          value: {
            data,
            params
          }
        })
        return data
      })
      .catch((error) => {
        this.$showError(error.toString())
        return []
      })
  }
}
